<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <v-card dark>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Create Monitoring Location</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
    <v-card>
      <LocationForm v-if="dialog" ref="form" />
      <v-card-text>
        <strong>Note:</strong> Data sources can be attached in the `Data Sources` tab after you create this monitoring location.
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn color="success" :loading="loading" @click="submit()">
          <v-icon class="mr-2">add</v-icon>
          Save
        </v-btn>
        <v-btn depressed :disabled="loading" @click="close()">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  const dataSources = createNamespacedHelpers('datasource')
  const app = createNamespacedHelpers('app')
  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')

  import LocationForm from './LocationForm'

  export default {
    components: {
      LocationForm,
    },
    data: () => ({
      dialog: false,
      loading: false,
    }),
    methods: {
      ...monitoringFeatures.mapActions(['createMonitoringFeature']),
      ...app.mapActions(['setSnackbar']),
      ...dataSources.mapActions(['setDSMonitoringFeatureId']),
      close() {
        this.dialog = false
        this.loading = false
      },
      show() {
        this.dialog = true
      },
      async submit() {
        if (!this.$refs.form.validate()) return

        this.loading = true
        try {
          let payload = this.$refs.form.getForm()
          let promises = []

          let monitoringFeature = await this.createMonitoringFeature({
            monitoringFeature: payload,
          })

          if (payload.dataTypes) {
            payload.dataTypes.forEach(dt => {
              dt.monitoringFeatureId = monitoringFeature.Id
              let promise = this.setDSMonitoringFeatureId(dt)
              promises.push(promise)
            })
          }

          await Promise.all(promises)

          this.setSnackbar({
            text: 'Location created',
            color: 'success',
            icon: 'done',
            timeout: 10000,
          })

          this.close()
        } catch (error) {
          console.error(error)
          this.setSnackbar({
            text: error && error.Message,
            color: 'error',
            icon: 'error',
            timeout: 10000,
          })
        }

        this.loading = false
      },
    },
  }
</script>